/**
 * API Comunicaciones: newsletters, personalizados, redes sociales.
 */

function getBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  return '/api';
}

export type CommunicationType = 'newsletter' | 'draft' | 'social';

export interface CommunicationItem {
  id: number;
  type: string;
  title: string;
  content: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export async function getCommunications(type: CommunicationType): Promise<{ success: boolean; items: CommunicationItem[] }> {
  const res = await fetch(`${getBaseUrl()}/communications/${type}`, { credentials: 'include' });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error al listar');
  return data;
}

export async function createCommunication(
  type: CommunicationType,
  body: { title?: string; content?: string }
): Promise<{ success: boolean; item: CommunicationItem }> {
  const res = await fetch(`${getBaseUrl()}/communications/${type}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error al crear');
  return data;
}

export async function updateCommunication(
  type: CommunicationType,
  id: number,
  body: { title?: string; content?: string; sort_order?: number }
): Promise<{ success: boolean; item: CommunicationItem }> {
  const res = await fetch(`${getBaseUrl()}/communications/${type}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error al actualizar');
  return data;
}

export async function deleteCommunication(type: CommunicationType, id: number): Promise<{ success: boolean }> {
  const res = await fetch(`${getBaseUrl()}/communications/${type}/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error al eliminar');
  return data;
}
